import _Vue from "vue";
import { GtagOptions } from "./config";
import {
  disableGtag,
  gtagExists,
  initDataLayer,
  loadGtag,
  removeGtag
} from "./utils";

export default {
  install(Vue: typeof _Vue, options: GtagOptions) {
    if (options.config.enabled) {
      const { id, conversion_id } = options.config;
      !gtagExists() &&
        loadGtag(id, () => {
          if (typeof window !== "undefined") {
            localStorage.setItem("GDPR-accepted", "true");
          }
        })
          .then(() => {
            initDataLayer(id, conversion_id);
          })
          .catch(error => console.warn(error));
    }

    Vue.prototype.$gtag = {
      optIn() {
        const { id, conversion_id } = options.config;
        options.config.enabled = true;
        !gtagExists() &&
          loadGtag(id, () => {
            if (typeof window !== "undefined") {
              localStorage.setItem("GDPR-accepted", "true");
            }
          })
            .then(() => {
              initDataLayer(id, conversion_id);
            })
            .catch(error => console.warn(error));
      },
      optOut() {
        const { id } = options.config;
        options.config.enabled = false;
        disableGtag(id, true);
        if (typeof window !== "undefined") {
          gtagExists()
            ? removeGtag(() => localStorage.setItem("GDPR-accepted", "false"))
            : localStorage.setItem("GDPR-accepted", "false");
        }
      },
      event(...args: unknown[]) {
        if (!args || !gtagExists() || typeof window === "undefined") return;
        window.gtag("event", ...args);
      }
    };
  }
};
